import React from 'react';

type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
};

export function PwaInstallPrompt() {
  const [deferred, setDeferred] = React.useState<BeforeInstallPromptEvent | null>(null);
  const [dismissed, setDismissed] = React.useState(false);

  React.useEffect(() => {
    const onBeforeInstall = (e: Event) => {
      e.preventDefault();
      setDeferred(e as BeforeInstallPromptEvent);
    };
    window.addEventListener('beforeinstallprompt', onBeforeInstall);
    return () => window.removeEventListener('beforeinstallprompt', onBeforeInstall);
  }, []);

  if (!deferred || dismissed) return null;

  return (
    <div style={{ padding: '8px var(--gutter) 0', flexShrink: 0 }}>
      <div style={{
        background: 'var(--surface-card)', borderRadius: 'var(--radius-md)', padding: '12px 14px',
        boxShadow: 'var(--shadow-md)', display: 'flex', flexDirection: 'column', gap: 8,
      }}>
        <div style={{ fontWeight: 700, fontSize: 14 }}>Установить Коридор</div>
        <div style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Добавьте приложение на главный экран для быстрого доступа.</div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button type="button" onClick={() => setDismissed(true)}
            style={{ flex: 1, border: '1px solid var(--border-subtle)', background: 'transparent', borderRadius: 'var(--radius-sm)', padding: '8px 12px', cursor: 'pointer' }}>
            Позже
          </button>
          <button type="button" onClick={() => {
            void deferred.prompt().then(() => setDismissed(true));
          }}
            style={{ flex: 1, border: 'none', background: 'var(--accent)', color: '#fff', borderRadius: 'var(--radius-sm)', padding: '8px 12px', fontWeight: 600, cursor: 'pointer' }}>
            Установить
          </button>
        </div>
      </div>
    </div>
  );
}
